(function () {
  function initFeed(root) {
    if (!root || root.dataset.mkJournalReady === '1') return;
    root.dataset.mkJournalReady = '1';

    var blogUrl = root.getAttribute('data-blog-url') || '';
    var pageSize = parseInt(root.getAttribute('data-page-size') || '5', 10) || 5;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mk-journal-tab]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mk-journal-item]'));
    var emptyEl = root.querySelector('[data-mk-journal-empty]');
    var moreWrap = root.querySelector('[data-mk-journal-more]');
    var moreBtn = root.querySelector('[data-mk-journal-more-btn]');
    var activeTag = root.getAttribute('data-initial-tag') || 'all';
    var visibleCount = 0;
    var onTaggedPage = /\/tagged\//.test(window.location.pathname);

    function matches(item, tag) {
      if (tag === 'all') return true;
      var tags = (item.getAttribute('data-tags') || '').trim().split(/\s+/).filter(Boolean);
      return tags.indexOf(tag) !== -1;
    }

    function matchedItems(tag) {
      return items.filter(function (item) {
        return matches(item, tag);
      });
    }

    function setHidden(el, hide) {
      if (!el) return;
      el.classList.toggle('is-hidden', !!hide);
    }

    function render() {
      var matched = matchedItems(activeTag);
      items.forEach(function (item) {
        setHidden(item, true);
      });
      matched.forEach(function (item, index) {
        setHidden(item, index >= visibleCount);
      });
      setHidden(emptyEl, matched.length > 0);
      setHidden(moreWrap, visibleCount >= matched.length);
    }

    function setTab(tag, pushHash) {
      activeTag = tag || 'all';
      visibleCount = pageSize;

      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-mk-journal-tab') === activeTag;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      render();

      if (pushHash && window.history && window.history.replaceState) {
        var next =
          window.location.pathname +
          window.location.search +
          (activeTag === 'all' ? '' : '#' + encodeURIComponent(activeTag));
        try {
          window.history.replaceState(null, '', next);
        } catch (e) {}
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var tag = tab.getAttribute('data-mk-journal-tab') || 'all';
        if (onTaggedPage && tag !== activeTag) {
          window.location.href = blogUrl + (tag === 'all' ? '' : '#' + encodeURIComponent(tag));
          return;
        }
        setTab(tag, true);
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function (event) {
        event.preventDefault();
        visibleCount += pageSize;
        render();
      });
    }

    if (window.location.hash) {
      try {
        activeTag = decodeURIComponent(window.location.hash.replace(/^#/, '')) || activeTag;
      } catch (e) {
        activeTag = window.location.hash.replace(/^#/, '') || activeTag;
      }
    }

    setTab(activeTag, false);
  }

  function initAll() {
    document.querySelectorAll('[data-mk-journal-feed]').forEach(initFeed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
